import React from 'react';

import {
  ItemCardContainer,
  ItemCardImage,
  ItemName,
  ItemPrice,
  ItemInfoContainer,
} from './styles';

export default function ItemInfo({ itemData }) {
  return (
    <ItemCardContainer>
      <ItemCardImage src={itemData.imageUrl} />
      <ItemInfoContainer>
        <ItemName>{itemData.name}</ItemName>
        <ItemPrice>{`R$${itemData.price}`}</ItemPrice>
      </ItemInfoContainer>
    </ItemCardContainer>
  );
}
